import { useEffect } from 'react';

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

/**
 * @hook usePostHogEvents
 */
export const usePostHogEvents = () => {
    useEffect(() => {
        const hubspotEventListener = (/** @type {MessageEvent} */ event) => {
            if (window.posthog && event?.data?.type === 'hsFormCallback') {
                if (event.data.eventName === 'onFormSubmit') {
                    window.posthog.capture('hubspot_form_submitted', {
                        'form_id': event.data.id
                    });
                }
                if (event?.data?.eventName === 'onFormSubmitted') {
                    window.posthog.capture('hubspot_form_submission_confirmed', {
                        'form_id': event.data.id
                    });
                }
            }
        };

        window.addEventListener('message', hubspotEventListener);

        return () => {
            window.removeEventListener('message', hubspotEventListener);
        };
    }, []);

    return;
};

// export const postHogDataAttributes = () => {
//     return {
//         'data-analytics-id': '',
//         'data-analytics-action': '',
//         'data-analytics-location': '',
//         'data-analytics-context': '',
//         'data-analytics-label': '',
//         'data-analytics-destination': '',
//         'data-analytics-module': '',
//     };
// };
